import { render, staticRenderFns } from "./create_person_list.vue?vue&type=template&id=6ca6a190&scoped=true"
import script from "./create_person_list.vue?vue&type=script&lang=js"
export * from "./create_person_list.vue?vue&type=script&lang=js"
import style0 from "./create_person_list.vue?vue&type=style&index=0&id=6ca6a190&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca6a190",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca6a190')) {
      api.createRecord('6ca6a190', component.options)
    } else {
      api.reload('6ca6a190', component.options)
    }
    module.hot.accept("./create_person_list.vue?vue&type=template&id=6ca6a190&scoped=true", function () {
      api.rerender('6ca6a190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal_order/terminal_market_activities/components/create_person_list.vue"
export default component.exports